import React from 'react';

export const Shared: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="14"
      height="14"
      viewBox="0 0 64 64"
      xmlSpace="preserve"
    >
      <g>
        <path
          d="M52 42a10 10 0 0 0-7.86 3.83L21.65 34.59a9.89 9.89 0 0 0 0-5.18l22.49-11.24C49.9 25.56 62 21.49 62 12a10 10 0 1 0-19.65 2.59L19.86 25.83C14.1 18.44 2 22.51 2 32s12.1 13.56 17.86 6.17l22.49 11.24A10 10 0 0 0 52 62c13.27-.55 13.26-19.45 0-20z"
          fill="#014d4e"
          opacity="1"
        />
      </g>
    </svg>
  );
};
